(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.List",
                {
                    url: "/List",
                    component: "reportList",
                    data: {
                        pageTitle: "Reports"
                    }
                });
        }
    ]);

    app.component("reportList",
        {
            templateUrl: "/App/Reports/ReportList/reportlist-template.html",
            controller: reportListController,
            bindings: {
                currentUser: "<"
            }
        });

    reportListController.$inject = ["_", "$scope", "$state", "$mdDialog", "$timeout", "reportApi", "userApi"];
    function reportListController(_, $scope, $state, $mdDialog, $timeout, reportApi, userApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                sortBy: { col: "Name", asc: true },
                reportsLimit: 10,
                openShareReport: openShareReport,
                editReport: editReport,
                deleteReport: deleteReport,
                copyReport: copyReport,
                runReport: runReport,
                toggleSort: toggleSort,
                exportReport: exportReport
            });

        $scope.$on("sharedWithUpdated",
            function (event, data) {
                var report = _.find($ctrl.reports,
                    function (r) {
                        return r.Id === data.Id;
                    });

                report.IsPublic = data.IsPublic;
                report.SharedWith = data.SharedWith;
                report.Visibility = data.Visibility;
            });

        function editReport(report) {
            $state.go("Home.Reports.Edit", { type: report.Type, reportId: report.Id });
        }

        function openShareReport(report, $event) {
            var alert = $mdDialog.alert({
                templateUrl: "/App/Reports/ReportList/ShareReport/sharereport-template.html",
                controller: "shareReportController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                clickOutsideToClose: true,
                resolve: {
                    report: [function () {
                        return ng.copy(report);
                    }],
                    currentUser: [function () {
                        return $ctrl.currentUser;
                    }]
                }
            });
            $mdDialog.show(alert).then(function (response) {
                var isEqual = _.isEqual(report, response);
                if (!isEqual) {
                    report = response;
                }
            });
        }

        function deleteReport(reportId, $event) {
            var confirm = $mdDialog.confirm({
                focusOnOpen: false,
                theme: "confirmDelete",
                title: "Delete Report",
                textContent:
                    "Are you sure you want to delete this report? All users you have shared this report with will no longer have access to it.",
                targetEvent: $event,
                ariaLabel: "Confirm report deletion",
                ok: "Delete",
                cancel: "Cancel",
                clickOutsideToClose: false
            });

            $mdDialog.show(confirm).then(function () {
                _.remove($ctrl.reports,
                    function (report) {
                        return report.Id === reportId;
                    });

                reportApi.deleteReport(reportId);
            });
        }

        function copyReport(report) {
            var reportCopy = {
                Name: report.Name + " - Copy",
                Type: report.Type,
                CustomProperties: report.CustomProperties ? report.CustomProperties : null,
                Properties: report.Properties,
                IsPublic: false,
                Visibility: "Private",
                OwnerId: $ctrl.currentUser.Id,
                Owner: $ctrl.currentUser,
                ModifiedById: $ctrl.currentUser.Id,
                ModifiedBy: $ctrl.currentUser,
                ModifiedOn: new Date()
            };

            $ctrl.reports.push(reportCopy);

            reportApi["create" + report.Type + "Report"](reportCopy).then(function (response) {
                reportCopy.Id = response.Id;
            });
        }

        function runReport(report) {
            sessionStorage.setItem("__report", JSON.stringify(report));
            $state.go("Home.Reports.Results");
        }

        function getReportFile(exportedReportId) {
            return reportApi.getExportedReport(exportedReportId).then(function (response) {
                if (response === null)
                    return getReportFile(exportedReportId);
                else return response;
            });
        }

        function exportReport(report) {
            $ctrl.ui.exporting = true;

            reportApi.export(report).then(function (response) {
                getReportFile(response.Id).then(function (file) {
                    var f = document.createElement("a");
                    document.body.appendChild(f);
                    f.style = "display:none";

                    var fUrl = window.URL.createObjectURL(file);
                    f.href = fUrl;
                    f.download = report.Name ? report.Name + ".xls" : "untitled.xls";
                    f.click();
                    $ctrl.ui.exporting = false;

                    $timeout(function () {
                        document.body.removeChild(f);
                        window.URL.revokeObjectURL(fUrl);
                    },
                        100);
                });
            });
        }

        function toggleSort(col) {
            if ($ctrl.sortBy.col === col)
                $ctrl.sortBy.asc = !$ctrl.sortBy.asc;
            else
                $ctrl.sortBy = { col: col, asc: true };

            return refreshList();
        }

        function refreshList() {
            $ctrl.reports = _.sortBy($ctrl.reports,
                function (report) {
                    switch ($ctrl.sortBy.col) {
                        case "Owner":
                            return [report.Owner.FirstName, report.Owner.LastName];
                        case "Visibility":
                        case "Name":
                        case "ModifiedOn":
                        default:
                            return report[$ctrl.sortBy.col];
                    }
                });

            if (!$ctrl.sortBy.asc) $ctrl.reports = $ctrl.reports.reverse();
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.loadingReports = true;
            $ctrl.reports = [];

            reportApi.getPublicReports().then(function (publicReports) {
                ng.forEach(publicReports,
                    function (r) {
                        r.Visibility = "Public";
                    });

                $ctrl.reports = $ctrl.reports.concat(publicReports);

                reportApi.getUserReports($ctrl.currentUser.Id).then(function (userReports) {
                    ng.forEach(userReports,
                        function (r) {
                            r.Visibility = r.SharedWith.length > 0 ? "Individuals" : "Private";
                        });

                    $ctrl.reports = $ctrl.reports.concat(userReports);

                    reportApi.getUserSharedReports($ctrl.currentUser.Id).then(function (sharedReports) {
                        var rs = _.map(sharedReports,
                            function (report) {
                                return report.Report;
                            });

                        ng.forEach(rs,
                            function (r) {
                                r.Visibility = "Individuals";
                            });

                        $ctrl.reports = $ctrl.reports.concat(rs);

                        //removes the duplicate shared reports that show up when:
                        //  - a user has previously shared a report before making that report public
                        //  - a user's report that has also been made public
                        $ctrl.reports = _.uniqBy($ctrl.reports, "Id");
                        refreshList();

                        $ctrl.ui.loadingReports = false;
                    });
                });
            });

            userApi.getUsers().then(function (response) {
                $ctrl.users = response;
            });
        }
    }

})(window.app, window.angular);